{ avatarDomain } = require '@trello/config'
t = require('app/scripts/views/internal/teacup-with-helpers')('invitee_orientation')

module.exports = t.renderable ({ visibleMembersCount, maxVisible, firstMemberFullName, boardName, inviterAvatarHash, inviterFullName, inviterUsername, inviterInitials })->
  t.div '.invitee-orientation-message-container.arrow', ->
    t.a '.js-close-orientation.pop-over-header-close-btn.close-invitee-orientation.icon-sm.icon-close', { href: '#' }

    t.h1 =>
      t.format 'welcome-to-trello-wave'

    t.div ->
      t.div '.orientation-header', ->
        t.div '.board-header-facepile.invitee-orientation-facepile.js-invitee-orientation-facepile'

        t.div '.orientation-facepile-text', ->
          if visibleMembersCount > 0
            t.b ->
              t.text firstMemberFullName
              t.raw '&nbsp;'

            if visibleMembersCount == 1
              t.format 'is-also-here'
            else
              if visibleMembersCount == 2
                t.format "one-other-is-here"
              else
                t.format 'count-others-are-here', count: visibleMembersCount - 1

      t.div '.invitee-orientation-text.u-clearfix', ->
        t.p ->
          t.format 'main-message', { boardName }
        t.p ->
          t.format 'that-s-all'

  t.div '.invitee-orientation-avatar-container', ->
    if inviterAvatarHash
      t.img '.invitee-orientation-avatar',
        src: [avatarDomain, inviterAvatarHash, '50.png'].join('/')
        alt: inviterFullName
        title: "#{ inviterFullName} (#{ inviterUsername })",
    else
      t.div '.invitee-orientation-initials-wrapper', ->
        t.span '.invitee-orientation-initials', ->
          t.text inviterInitials
